<template>
  <div>
    <template v-if="userType !== userTypesGetValue('INDIVIDUAL_ENTITY')">
      <div class="my-5">
        <p class="text-xs text-gray-500">{{ $lang.app.SURNAME }}</p>
        <p class="min-h-6">{{ contactDetail?.surname }}</p>
        <hr />
      </div>
      <div class="my-5">
        <p class="text-xs text-gray-500">{{ $lang.app.NAME }}</p>
        <p class="min-h-6">{{ contactDetail?.name }}</p>
        <hr />
      </div>
      <div class="my-5">
        <p class="text-xs text-gray-500">{{ $lang.app.PATRONYMIC }}</p>
        <p class="min-h-6">{{ contactDetail?.patronymic }}</p>
        <hr />
      </div>
    </template>
    <div class="my-5">
      <p class="text-xs text-gray-500">{{ $lang.app.WORK_PHONE }}</p>
      <p class="min-h-6">{{ contactDetail?.phoneWork }}</p>
      <hr />
    </div>
    <div class="my-5">
      <p class="text-xs text-gray-500">{{ $lang.app.TELEPHONE }}</p>
      <p class="min-h-6">{{ contactDetail?.phone }}</p>
      <hr />
    </div>
    <div class="my-5">
      <p class="text-xs text-gray-500">{{ $lang.app.EMAIL }}</p>
      <p class="min-h-6">{{ contactDetail?.email }}</p>
      <hr />
    </div>
  </div>
</template>
<script>
import {getValueByKey as userTypesGetValue} from "../../../../helpers/constants/userTypes";
export default {
  props: {
    userType: Number,
    contactDetail: Object,
  },
  methods: {
    userTypesGetValue,
  }
}
</script>